export function calculateSequence(
  array: Array<{ id: string }>,
  sourceIndex: number,
  destinationIndex: number
) {
  const sequence = array.map((h) => h.id);

  const element = sequence[sourceIndex];
  sequence.splice(sourceIndex, 1);
  sequence.splice(destinationIndex, 0, element);

  const idSequenceMap = Object.fromEntries(sequence.map((id, i) => [id, i]));

  return idSequenceMap;
}
